// UserRolesService.ts
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import OrganizationId from "../../interfaces/identity/OrganizationId";
import Role from "../../interfaces/identity/Role"; // Import Role interface
import { GetReportBody, GetTeamBody, reportTo, teams } from "../../interfaces/team/RegionHierarchy";

// Function to fetch a user's role by their user id
export async function getRoleByUserId(authToken: string): Promise<Role[] | null> {

  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/users/roles` 

  try {
    const response = await fetch(
      apiUrl, 
      {headers: { 
        'Authorization': `Bearer ${authToken}`
      }}
    );

    if (!response.ok) {
      // Handle non-OK responses, e.g., 404 for not found
      console.error(`Server responded with status: ${response.status}`);
      return null;
    }

    const roleData = await response.json();

    // Map the role data to Role interface
    const roles: Role[] = roleData.map((rd: any) => ({
      name: rd.name,
      premissions: rd.premissions ? rd.permissions : [],
      // Add other necessary properties
    }));

    return roles;
  } catch (error) {
    // Handle network errors or other exceptions
    console.error("Error fetching task:", error);
    return null;
  }
}

// Function to fetch all possible roles
export async function getRoles(authToken: string): Promise<Role[] | null> {

  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/users/allRoles` 

  try {
    const response = await fetch(
      apiUrl, 
      {headers: { 
        'Authorization': `Bearer ${authToken}`
      }}
    );

    if (!response.ok) {
      // Handle non-OK responses, e.g., 404 for not found
      console.error(`Server responded with status: ${response.status}`);
      return null;
    }

    const roleData = await response.json();

    // Map the role data to Role interface
    const roles: Role[] = roleData.map((rd: any) => ({
      id: rd.id,
      name: rd.name,
      // Add other necessary properties
    }));

    return roles;
  } catch (error) {
    // Handle network errors or other exceptions
    console.error("Error fetching task:", error);
    return null;
  }
}

export async function getOrganizations(authToken: string): Promise<OrganizationId[] | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/Authentication/OrganizationDetails`;

  try {
    const response = await fetch(apiUrl, {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });

    if (!response.ok) {
      console.error(`Server responded with status: ${response.status}`);
      return null;
    }

    const responseData = await response.json();
    console.log(responseData);

    const organizations: OrganizationId[] = responseData.data.map((org: any) => ({
      id: org.id,
      name: org.name
    }));

    return organizations;
  } catch (error) {
    console.error("Error fetching organizations:", error);
    return null;
  }
}

export async function getReportTo(
  authToken: string,
  reportbody: GetReportBody
): Promise<ApiResponse<reportTo[]>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/higherroles`;


  console.log('Request Body', reportbody);
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reportbody)
    });
    const responseData = await response.json();
  console.log('reportsTo', responseData);

    return responseData;
  } catch (error) {
    console.error("Error fetching reportTo:", error);
    throw error;
  }
}

export async function getTeam(
  authToken: string,
  reportbody: GetTeamBody
): Promise<teams[] | null> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/TeamandRegion/GetTeamsByRegionAndRole`;

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reportbody)
    });

    if (!response.ok) {
      console.error(`Server responded with status: ${response.status}`);
      return null;
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error fetching reportTo:", error);
    return null;
  }
}

